<template>
  <div>
    <card-item
      v-for="item in items" :key="item.id"
      :item="item"
      :row-meta="rowMeta"
      :column-meta="columnMeta"
      :action-meta="actionMeta"
      :showContextMenu="showContextMenu"
      @rowAction="rowAction"
      @fieldAction="fieldAction"
    />
  </div>
</template>

<script>
import CardItem from '@/components/table/CardItem'

export default {
  props: ['items', 'rowMeta', 'columnMeta', 'actionMeta', 'showContextMenu'],
  components: {
    CardItem
  },
  methods: {
    fieldAction (action, item) {
      this.$emit('fieldAction', action, item)
    },
    rowAction (action, item) {
      this.$emit('rowAction', action, item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/table/CardList.vue